import React from 'react';
import { Box } from '@mui/material';
import Programs from './programcards';

const Programas = () => (
  <Box id="programas" sx={{ py: 5, px: 2 }}>
    <Programs/>
  </Box>
);

export default Programas;